import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-generica2',
  templateUrl: './generica2.component.html',
  styleUrls: ['./generica2.component.scss']
})
export class Generica2Component implements OnInit {

  constructor(private router: Router, private titleService: Title) {
    this.titleService.setTitle("RECORRIDOS: MIRADAS DESDE EL ARTE");
  }

  ngOnInit(): void {
  }

  //genericas
  creadores() {
    this.router.navigate(['/home/generica1']);
  }
  miradasArta() {
    this.router.navigate(['/home/generica2']);
  }
  comunidadesImg() {
    this.router.navigate(['/home/generica3']);
  }
  transiciones() {
    this.router.navigate(['/home/generica4']);
  }
  //micrositios
  Pensadoras() {
    this.router.navigate(['/micrositio10/pensadoresXIX']);
  }
  Clorinda() {
    this.router.navigate(['/micrositio9/clorindaMatto']);
  }
  JoseEguren() {
    this.router.navigate(['/micrositio8/artePoeta']);
  }
  MagdaPortal() {
    this.router.navigate(['/micrositio13/magda-portal']);
  }
  JoseMariaArguedas() {
    this.router.navigate(['/micrositio14/jose-maria-arguedas']);
  }
  RetratoFoto() {
    this.router.navigate(['/micrositio3/retrato-foto']);
  }
  RetratoInmigracion() {
    this.router.navigate(['/micrositio11/retratos-inmigracion']);
  }
  AlbumRepublica() {
    this.router.navigate(['/micrositio5/album-republica-peruana']);
  }
  MalagaGrenet() {
    this.router.navigate(['/micrositio12/malaga-grenet']);
  }
  Compositores() {
    this.router.navigate(['/micrositio2/compositores']);
  }
  Gramaticas() {
    this.router.navigate(['/micrositio6/gramaticas']);
  }
  MiradasAntiguoPeru() {
    this.router.navigate(['/micrositio15/miradas-al-antiguo-peru']);
  }
  LaEducacion() {
    this.router.navigate(['/micrositio4/la-educacion']);
  }
  Himnos() {
    this.router.navigate(['/micrositio7/himnos']);
  }
  Federalismo() {
    this.router.navigate(['/micrositio1/federalismo']);
  }
  DoraMayer(){
    this.router.navigate(['/micrositio16/dora-mayer']);
  }
  ManuelGP(){
    this.router.navigate(['/micrositio17/manuel-gonzalez-prada']);
  }
  RicardoPalma(){
    this.router.navigate(['/micrositio19/ricardo-palma']);
  }
  JorgeBasadre(){
    this.router.navigate(['/micrositio23/jorge-basadre']);
  }
  Reportaje2(){
    this.router.navigate(['/micrositio42/noticieros2']);
  }
  Reportaje(){
    this.router.navigate(['/micrositio18/noticieros']);
  }
  Construccion(){
    this.router.navigate(['/micrositio21/construccion-tradicion']);
  }
  Garcilaso(){
    this.router.navigate(['/micrositio24/inca-garcilaso']);
  }
  DerechosMujer(){
    this.router.navigate(['/micrositio20/derechos-mujer']);
  }
  Imprenta(){
    this.router.navigate(['/micrositio22/imprenta']);
  }
  Album(){
    this.router.navigate(['/micrositio27/album-autografos']);
  }
  Exlibris(){
    this.router.navigate(['/micrositio29/ex-libris']);
  }
  Moda(){
    this.router.navigate(['/micrositio31/moda-siglo']);
  }
  Renacer(){
    this.router.navigate(['/micrositio33/renacer-cenizas']);
  }
}
